import FrameworkCourseController from "../../../framework-course.controller";

class Diagram3Controller extends FrameworkCourseController {

  constructor(courseService, diagramService, $translate, $timeout, $scope) {
    'ngInject';
    super(courseService, diagramService, $translate, $timeout, $scope);
    this.isFiveSection = true
    this.amountCorrectAnswers = 9;
    this.exerciseId = 'exercise-2'
    this.clearDiagramId = 2
    this.pyramidData = {
      exerciseNumber: 2,
      scheme: {
        model: {
          textarea: 'Appoint an additional person to synchronize the activities of all 5 projects, with Program Manager, other managers, and implementation teams',
        },
        children: [
          {
            model: {
              textarea: 'Work with the teams to uncover duplication, align implementation dates',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Create a program plan identifying critical milestones determined',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Report on progress and achievement of the program to the PCIIT',
            },
            children: [

            ]
          },
        ],
      },
      scq: {
        's-header': 'Sit',
        'c-header': 'DE, R1a. R2a, Sol, R1b, R2b, Solb',
      },
    };
  }

}

export default Diagram3Controller;



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5d/diagram3/diagram3.controller.js